<div *ngIf="userInfo" class="user__info">
  {{ 'HEADER.user_info' | translate }}
  <a [routerLink]="['/' + RoutesPath.default.account]" style="text-decoration: underline">{{
    'HEADER.user_info_link' | translate
  }}</a
  >.
</div>

<app-mobile-app-banner></app-mobile-app-banner>

<app-header-desktop
  class="header-desktop"
  (cartListLengthEmitter)="setCartListLength($event)"
  [notificationsUnseen]="notificationsUnseen"
  (getStatistictEmitter)="getNotificationsStatistics()"
></app-header-desktop>

<app-header-mobile
  [notificationsUnseen]="notificationsUnseen"
  [cartListLength]="cartListLength"
  (openMobileMenuEmitter)="getNotificationsStatistics()"
  (closeNotificationsEmitter)="getNotificationsStatistics()"
></app-header-mobile>
